<template>
  <transition name="fade">
    <div class="level3-landingpage-container">
      <div class="lv3-title-text">Tambah Pic Data</div>
      <div class="lv3-edit-form" style="overflow-y: auto !important">
        <div class="edit-form-wrapper">
          <div>Nama</div>
          <input
            class="lv3-input-text"
            type="text"
            v-model="namaPic"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
          />
        </div>
        <div class="edit-form-wrapper">
          <div>Nomor Handphone</div>
          <div class="phone-add">
            <the-mask
              class="phone-add__phone"
              :mask="['+## ####################']"
              v-model="$store.state.landingpage.phonePic"
            />
          </div>
        </div>
        <div class="edit-form-wrapper">
          <div>Email</div>
          <input
            class="lv3-input-text"
            type="text"
            v-model="emailPic"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
          />
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="submitForm()">CONFIRM</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['propsData'],
  data() {
    return {
      jabatan: '',
      nama: '',
      phoneNumber: '',
      email: '',
    }
  },
  computed: {
    namaPic: {
      get: function() {
        return this.$store.state.landingpage.namaPic
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'namaPic',
          value: newValue,
        })
      },
    },
    emailPic: {
      get: function() {
        return this.$store.state.landingpage.emailPic
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'emailPic',
          value: newValue,
        })
      },
    },
  },
  methods: {
    submitForm() {
      if (this.checkForm()) {
        this.confirm()
      }
    },
    checkForm() {
      let arr = [
        [this.namaPic, 'Nama Person In Charge'],
        [this.$store.state.landingpage.phonePic.length > 3, 'No Telepon'],
        [this.isEmailValid(this.emailPic), 'Email'],
      ]

      return this.multiConditions(arr)
    },
    closeModal() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addPic',
        value: false,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editPic',
        value: false,
      })
    },
    confirm() {
      if (this.$store.state.landingpage.addPic) {
        let picData = {
          id: this.$store.state.landingpage.picIndex + 1,
          nama: this.namaPic,
          phoneNumber: this.$store.state.landingpage.phonePic,
          email: this.emailPic,
        }

        this.$store.commit('landingpage/SET_ARRAY_DATA', {
          name: 'picList',
          value: picData,
          operation: 'add',
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'picIndex',
          value: picData.id + 1,
        })
      } else if (this.$store.state.landingpage.editPic) {
        let picData = {
          id: this.$store.state.landingpage.idPic,
          nama: this.namaPic,
          phoneNumber: this.$store.state.landingpage.phonePic,
          email: this.emailPic,
        }

        this.$store.commit('landingpage/SET_ARRAY_DATA', {
          name: 'picList',
          value: picData,
          operation: 'edit',
        })
      }

      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'namaPic',
        value: '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'phonePic',
        value:
          this.$get(this.$store, 'state.landingpage.choosedCountry.id') == 63
            ? 62
            : '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'emailPic',
        value: '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addPic',
        value: false,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editPic',
        value: false,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/login.scss';
</style>
